import {
  getHighlightedParts,
  getPropertyByPath,
  unescape,
} from 'instantsearch.js/es/lib/utils'
import React, { createElement, Fragment } from 'react'

// import { Snippet as SnippetUiComponent } from 'react-instantsearch/dist/es/ui/Snippet.js';

import { cx, createHighlightComponent } from 'instantsearch-ui-components'

const InternalHighlight = createHighlightComponent({
  createElement: createElement,
  Fragment,
})

/// ////////////////////////

function SnippetUiComponent ({ classNames = {}, ...props }) {
  return (
    <InternalHighlight
      classNames={{
        root: cx('ais-Snippet', classNames.root),
        highlighted: cx('ais-Snippet-highlighted', classNames.highlighted),
        nonHighlighted: cx(
          'ais-Snippet-nonHighlighted',
          classNames.nonHighlighted,
        ),
        separator: cx('ais-Snippet-separator', classNames.separator),
      }}
      {...props}
    />
  )
}

/// ////////////////////////

const trimTooLong = (value, max) => {
  if (value.length > max) { return value.slice(0, max) + '...' }
  return value
}

export function SnippetWithTrimIfNotHighlighted ({
  hit,
  attribute,
  highlightedTagName,
  nonHighlightedTagName,
  separator,
  ...props
}) {
  const property =
    getPropertyByPath(hit._snippetResult, attribute) || []
  const properties = Array.isArray(property) ? property : [property]

  const parts = properties.map((singleValue) =>
    getHighlightedParts(unescape(singleValue.value || '')),
  )

  // console.log({
  //   parts,
  //   properties,
  //   // parts_,
  // })

  const parts_ = parts.map(subParts => subParts.map(({ value, isHighlighted }) => {
    return { value: isHighlighted ? value : trimTooLong(value, 600), isHighlighted }
  }))

  return (
    <SnippetUiComponent
      {...props}
      parts={parts_}
      highlightedTagName={highlightedTagName}
      nonHighlightedTagName={nonHighlightedTagName}
      separator={separator}
    />
  )
}
